import React from 'react';
import classNames from 'classnames';
import DeviceIconCommon from '../../../../components/device-icon';
import {
  IconDeviceDinModuleWithAntenna,
  IconDeviceFlushMountedBlindController,
  IconDeviceFlushMountedController,
  IconDeviceFlushMountedGateAndGatewayController,
  IconDeviceFlushMountedGateController,
  IconDeviceFlushMountedRelay,
  IconDeviceFlushMountedRGBLightController,
} from '../../../../components/icons/device';
import { IconConnectionError } from '../../../../components/icons/icon-connection-error';
import { IconRecovery } from '../../../../components/icons/icon-recovery';
import { ChannelTypeInternal } from '../../../../data-access/gql-types/graphql';
import './index.scss';

type DeviceIconProps = {
  type?: ChannelTypeInternal;
  disconnected?: boolean;
  recovery?: boolean;
  statusIcon?: React.ReactNode;
};

const DeviceIcon: React.FC<DeviceIconProps> = ({ type, disconnected, recovery, statusIcon }) => {
  const getDeviceIcon = () => {
    switch (type) {
      case ChannelTypeInternal.Switch:
        return <IconDeviceFlushMountedRelay />;
      case ChannelTypeInternal.Light:
        return <IconDeviceFlushMountedRGBLightController />;
      case ChannelTypeInternal.Blind:
        return <IconDeviceFlushMountedBlindController />;
      case ChannelTypeInternal.Meter:
        return <IconDeviceDinModuleWithAntenna />;
      case ChannelTypeInternal.Optimizer:
        return <IconDeviceFlushMountedController />;
      case ChannelTypeInternal.Gate:
        return <IconDeviceFlushMountedGateController />;
      case ChannelTypeInternal.Door:
        return <IconDeviceFlushMountedGateAndGatewayController />;
      default:
        return <IconDeviceFlushMountedController />;
    }
  };

  const getStatusIcon = () => {
    if (statusIcon) return <div className="status-icon">{statusIcon}</div>;
    return disconnected ? (
      <IconConnectionError big details size={12} />
    ) : recovery ? (
      <IconRecovery big details />
    ) : null;
  };

  const icon = getDeviceIcon();
  const status = getStatusIcon();

  return <DeviceIconCommon icon={icon} statusIcon={status} />;
};

export default DeviceIcon;
